import { useTranslation } from 'react-i18next';
import {
  Checkbox as AntdCheckbox,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Radio,
  Divider,
  Typography,
  Select,
} from 'antd';
import { useMemo } from 'react';
import UIHelper from '../../../../../helpers/UIHelper';
import Helpers from 'helpers';
import { renderGroupedShopOptions } from 'components/shopOptions';

const FormSections = ({
  onChangeType,
  isAnonymous,
  shops,
  inactiveShops,
  countries,
  regions,
}) => {
  const { t } = useTranslation();
  const sex = useMemo(() => {
    return [
      {
        name: 'male',
        label: t('Uomo'),
      },
      {
        name: 'female',
        label: t('Donna'),
      },
    ];
  }, [t]);

  const ages = useMemo(() => {
    return [
      {
        value: 'Under 30',
        label: t('Under 30'),
      },
      {
        value: '30 - 40',
        label: '30 - 40',
      },
      {
        value: '40 - 50',
        label: '40 - 50',
      },
      {
        value: '50 - 60',
        label: '50 - 60',
      },
      {
        value: 'Over 60',
        label: t('Over 60'),
      },
    ];
  }, [t]);

  return (
    <>
      <Row gutter={20}>
        <Col span={6}>
          <Form.Item name='sex' label={t('Selezione sesso')}>
            <Radio.Group>
              {sex.map((item) => (
                <Radio value={item.name}>{item.label}</Radio>
              ))}
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item label={t('Selezione Fascia di Età')} name='age'>
            <Select placeholder={t('Selezione Fascia di Età')}>
              <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
              {ages.map((i) => (
                <Select.Option value={i.value}>{i.label}</Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Divider />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Title level={4}>
            {t('Selezione Provenienza')}
          </Typography.Title>
        </Col>
        <Col span={24}>
          <Row gutter={[20, 20]}>
            <Col span={8}>
              <Form.Item label={t('Seleziona la provincia')} name='region'>
                <Select
                  disabled={isAnonymous}
                  placeholder={t('Seleziona la provincia (per clienti IT)')}
                  {...UIHelper.getSelectSearchProps()}
                >
                  <Select.Option value={''}>
                    {t('Selezioni opzione')}
                  </Select.Option>
                  {regions?.map((i) => (
                    <Select.Option key={i.value} value={i.value}>
                      {i.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('seleziona paese')} name='country'>
                <Select
                  disabled={isAnonymous}
                  placeholder={t('seleziona paese (per clienti stranieri)')}
                  {...UIHelper.getSelectSearchProps()}
                >
                  <Select.Option value={''}>
                    {t('Selezioni opzione')}
                  </Select.Option>
                  {countries?.map((i) => (
                    <Select.Option key={i.value} value={i.value}>
                      {i.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                valuePropName='checked'
                name='sales_trackings_type'
                label={t('Sconosciuto')}
              >
                <Checkbox onChange={onChangeType}>{t('Sconosciuto')}</Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Divider />
        </Col>
      </Row>
      <Row gutter={[20, 20]}>
        <Col span={8}>
          <Form.Item label={t('Codice cliente')} name='customer_code'>
            <Input placeholder={t('inserisci codice cliente')} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={
              <span>
                {t('Importo')}{' '}
                <strong>{t('(utilizzare la virgola per i decimali)')}</strong>
              </span>
            }
            name='amount'
          >
            {/*eslint-disable-next-line*/}
            <Input placeholder={t("inserisci l'importo")} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={20}>
        <Col span={8}>
          <Form.Item
            valuePropName='checked'
            name='by_infopoint'
            label={t('Sconto Village Cards')}
          >
            <Checkbox>{t('Sconto Village Cards ')}</Checkbox>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('Seleziona insegna')} name='company_id'>
            <Select
              placeholder={t('Seleziona insegna')}
              {...Helpers.addSearchProps()}
            >
              <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
              {renderGroupedShopOptions({
                shops,
                inactiveShops,
                t,
                getValue: (shop) => shop.id,
              })}
            </Select>
          </Form.Item>
        </Col>
        <Form.Item name='is_stock_picking' hidden={true} />
        <Form.Item name='click_collect_order_id' hidden={true} />
      </Row>
    </>
  );
};

export default FormSections;
